import { pick, values } from 'lodash'

import INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS from './ingredient-keyword-column-allowed-operations'

const INGREDIENT_KEYWORD_TYPES = {
  SYNONYMS: {
    id: 'SYNONYMS',
    term: 'Synonyms',
    field: 'synonyms',
    maxLevel: 6,
    allowedOperations: values(INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS),
  },
  VARIETIES: {
    id: 'VARIETIES',
    term: 'Varieties',
    field: 'varieties',
    maxLevel: 6,
    allowedOperations: values(INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS),
  },
  UNCATEGORIZED: {
    id: 'UNCATEGORIZED',
    term: 'Uncategorized',
    field: 'uncategorized',
    maxLevel: 6,
    allowedOperations: values(
      pick(INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS, [
        'DELETE',
        'MOVE_COLUMN',
        'TRANSFER',
      ]),
    ),
  },
  DISCARDED: {
    id: 'DISCARDED',
    term: 'Discarded',
    field: 'discarded',
    maxLevel: 6,
    allowedOperations: values(
      pick(INGREDIENT_KEYWORD_COLUMN_ALLOWED_OPERATIONS, [
        'DELETE',
        'MOVE_COLUMN',
        'TRANSFER',
      ]),
    ),
  },
}

export default INGREDIENT_KEYWORD_TYPES
